<template>
  <a-modal
    class="create-evaluation-modal"
    title="撤回测评"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="text">您确定要撤回这个测评吗？</div>
  </a-modal>
</template>

<script>
import { putAction } from '@api/manage'

export default {
  name: 'CancleEvaluation',
  props: {
    evalOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      rowRecord: {},
    }
  },
  methods: {
    showModal(data) {
      this.visible = true
      this.rowRecord = data
      console.log('记录数据：', this.rowRecord)
    },
    hideModal() {
      this.visible = false
    },
    async handleOk() {
      const { id, evaluationIds, name, beginDate, endDate, gradeIds, classIds, evaluationMethod } =
        this.rowRecord

      const res = await putAction('/schoolEvaluationPlan/updateStatus', {
        id,
        evaluationIds,
        name,
        beginDate,
        endDate,
        gradeIds,
        classIds,
        evaluationMethod,
        status: 2,
      })
      if (res.success) {
        this.$emit('refreshTable')
        this.$message.success('撤回测评成功')
      }
      this.hideModal()
    },
    handleCancel() {
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less">
.text {
  padding: 20px 0;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
</style>
